module.exports = __webpack_public_path__ + "img/职工1级@3x.36f24321.png";